export default __webpack_public_path__ + "static/anyone-c34450935fedcbc4af07cca3e52154a4.svg";